<template>
  <div class="w-full h-full flex-grow max-h-full flex overflow-hidden">
    <!-- canvas 1 -->
    <Spinner v-if="!ready" class="flex-grow h-full flex flex-col"/>
    <div v-show="ready" ref="gridDiv" class="flex-grow h-full flex flex-col">

      <div class="flex-grow flex flex-col gap-2 content-center justify-center  items-center relative">

        <div v-if="props.changeTemplate" class="flex gap-2 h-[40px]  p-1 w-full">


          <template v-if="!isLayoutConfirmed">
            <button v-show="userData?.isAdmin || userData?.isMarketing" data-ui="reset-place-holder"
                    class="p-2 w-1/2 flex-grow bg-trader-gray hover:bg-trader-hover-background hover:text-trader-text"
                    @click="splitSelectedItem">
              Kombinierte Platzhalter auflösen
            </button>

            <button v-show="userData?.isAdmin || userData?.isMarketing" data-ui="confirm-layout"
                    class="p-2 w-1/2 bg-trader-green text-trader-dark-green hover:bg-trader-blue hover:text-white"
                    @click="confirmLayout">
              Raster fertig angepasst
            </button>
          </template>


          <template v-else>
            <button v-show="userData?.isAdmin || userData?.isMarketing"
                    class="p-2 bg-white hover:bg-trader-hover-background hover:text-white"
                    @click="resetLayout">
              ← Zurück
            </button>

            <div class="flex-grow text-center p-2 text-trader-blue font-semibold">
              Drag & Drop aktiv
            </div>
            <!--
            <button v-show="userData?.isAdmin || userData?.isMarketing && props.changeTemplate"
                    class="p-2 w-1/2 bg-trader-green text-trader-dark-green hover:bg-trader-blue"
                    @click="savePageTemplateWithProducts">
              Speichern
            </button>
            -->
            <TRAsyncButton v-if="userData?.isAdmin || userData?.isMarketing && props.changeTemplate" variant="save"
                           :saveSuccessful="!buttonIsSaving"
                           label="Speichern" loadingText="Speichere…" @click="savePageTemplateWithProducts"
                           data-ui="save-template"/>

          </template>


        </div>
        <div v-show="!props.changeTemplate && props.testPageId !== 0" class="flex gap-2 h-[40px] p-1 w-full"></div>


        <!--<MouseDebug class="absolute top-0 left-0 w-full h-full z-10"></MouseDebug>-->
        <canvas ref="grid"
                class="max-h-full max-w-full bg-trader-darker-gray w-full h-full z-0"
                data-ui="canvas-grid-page-view"></canvas>

      </div>


      <div ref="templateNameBar" class="bg-trader-gray w-full text-center p-2 flex gap-2 items-center justify-center">
        <span>Template Name:</span>
        <span>{{ data.pageTemplateName }}</span>
      </div>
    </div>


    <!-- sidebar -->
    <div class="w-2/6 flex flex-col" v-if="editMode" data-ui="grid-settings-menu">
      <div v-show="userData?.isAdmin || userData?.isMarketing" class="bg-primary flex-grow">
        <accordion ref="accordion" active="2">
          <accordion-item :padding="false">
            <!-- Page Settings -->
            <template v-slot:accordionTrigger="{ visible }">
              <div class=" flex p-2 ">
                <span v-if="visible"><i class="fa-solid fa-caret-down text-xl leading-5"></i></span>
                <span v-else><i class="fa-solid fa-caret-right text-xl leading-5"></i></span>
                <span class="ml-2" data-ui="accordion-page-setting">
                  Seiteneinstellungen
                </span>
              </div>
            </template>
            <template v-slot:accordionContent>
              <div class="overflow-auto ">
                <div class="m-2">
                  <div class="flex ">
                    <span class="w-28 my-2" data-ui="description-page-setting-input-top">Oben</span>
                    <input class="bg-white w-12 my-2 text-right" v-model="pageTop"
                           data-ui="page-setting-input-top">
                  </div>
                  <div class="flex">
                    <span class="w-28 my-2"
                          data-ui="description-page-setting-input-area-height"> Satzspiegel Höhe</span>
                    <input class="bg-inactive w-12 my-2 text-right" v-model="areaHeight" disabled
                           data-ui="page-setting-input-area-height">
                  </div>
                  <div class="flex">
                    <span class="w-28 my-2" data-ui="description-page-setting-input-bottom"> Unten</span>
                    <input class="bg-white w-12 my-2 text-right" v-model="pageBottom"
                           data-ui="page-setting-input-bottom">
                  </div>
                </div>
                <div class="m-2">
                  <div class="flex ">
                    <span class="w-28 my-2" data-ui="description-page-setting-input-left"> Links </span>
                    <input class=" bg-white w-12 my-2 text-right" v-model="pageLeft"
                           data-ui="page-setting-input-left">
                  </div>
                  <div class="flex">
                    <span class="w-28 my-2" disabled data-ui="description-page-setting-input-area-width"> Satzspiegel Weite </span>
                    <input class=" bg-inactive w-12 my-2 text-right" v-model="areaWidth" disabled
                           data-ui="page-setting-input-area-width">
                  </div>
                  <div class="flex">
                    <span class="w-28 my-2" data-ui="description-page-setting-input-right"> Rechts</span>
                    <input class="bg-white w-12 my-2 text-right" v-model="pageRight"
                           data-ui="page-setting-input-right">
                  </div>
                </div>
              </div>
            </template>
          </accordion-item>

          <accordion-item :padding="false">
            <template v-slot:accordionTrigger="{ visible }">
              <div class=" flex p-2 ">
                <span v-if="visible"><i class="fa-solid fa-caret-down text-xl leading-5"></i></span>
                <span v-else><i class="fa-solid fa-caret-right text-xl leading-5"></i></span>
                <span class="ml-2" data-ui="accordion-grid-design">
                  Raster Design
                </span>
              </div>
            </template>
            <template v-slot:accordionContent>
              <div class="m-2">
                <div class="flex">
                  <h1 class="p-2 mr-2 w-28" data-ui="description-grid-design-column-option"> Spalten</h1>
                  <select class="p-1 bg-white  my-1" v-model="settings.grid.columns"
                          data-ui="grid-design-column-option">
                    <option class="text-right" v-for="i in 20" :value="i" :key="i" :data-ui="'value-' + i">
                      {{ i }}
                    </option>
                  </select>
                </div>
                <div class="flex">
                  <h1 class="p-2 mr-2 w-28" data-ui="description-grid-design-input-column-distance">Spalten
                    abstand</h1>
                  <input class="my-2 bg-white w-12 text-right" v-model="settings.grid.columnsGap"
                         data-ui="grid-design-input-column-distance">
                </div>
                <div class="flex">
                  <h1 class="mr-2  p-2 w-28" data-ui="description-grid-design-row-option"> Zeilen </h1>
                  <select class="mr-4 p-1 my-1 bg-white" v-model="settings.grid.rows"
                          data-ui="grid-design-row-option">
                    <option class="text-right" v-for="i in 20" :value="i" :key="i" :data-ui="'value-' + i">
                      {{ i }}
                    </option>
                  </select>
                </div>
                <div class="flex">
                  <h1 class="p-2 mr-2 w-28" data-ui="description-grid-design-input-row-distance">Zeilen Abstand</h1>
                  <input class="my-2 bg-white w-12  text-right" v-model="settings.grid.rowsGap"
                         data-ui="grid-design-input-row-distance">
                </div>

                <div class="p-2 bg-primary flex w-full ">
                  <button class="bg-white p-2   mx-2 w-full hover:bg-trader-hover-background hover:text-white"
                          @click="newGenerate"
                          data-ui="button-new-generate-grid-settings">Neues Raster generieren
                  </button>
                </div>
              </div>
            </template>
          </accordion-item>

          <accordion-item :padding="false">
            <template v-slot:accordionTrigger="{ visible }">
              <div class=" flex p-2 ">
                <span v-if="visible"><i class="fa-solid fa-caret-down text-xl leading-5"></i></span>
                <span v-else><i class="fa-solid fa-caret-right text-xl leading-5"></i></span>
                <span class="ml-2" data-ui="accordion-article-setting">
                  Artikel Platzhalter
                </span>
              </div>
            </template>
            <template v-slot:accordionContent>
              <div class="flex  ml-4 ">
                <div class="w-1/3 ">
                  <div class="flex">
                    <h1 class="bg-black  dark:bg-white text-white w-4 text-center my-2"
                        data-ui="description-article-input-item-width">B</h1>
                    <input class="my-2 bg-white w-12 text-right" v-model="itemWidth"
                           data-ui="article-input-item-width">
                  </div>
                  <div class="flex">
                    <h1 class="bg-black dark:bg-white text-white w-4 text-center my-2"
                        data-ui="description-article-input-item-left">L</h1>
                    <input class="my-2 bg-white w-12 text-right " v-model="itemLeft"
                           data-ui="article-input-item-left">
                  </div>
                </div>
                <div class="w-1/3">
                  <div class="flex">
                    <h1 class="bg-black dark:bg-white text-white w-4 text-center my-2"
                        data-ui="description-article-input-item-height">H</h1>
                    <input class="my-2 bg-white w-12 text-right" v-model="itemHeight"
                           data-ui="article-input-item-height">
                  </div>
                  <div class="flex">
                    <h1 class="bg-black dark:bg-white text-white w-4 text-center my-2"
                        data-ui="description-article-input-item-top">
                      O</h1>
                    <input class="my-2 bg-white w-12  text-right" v-model="itemTop"
                           data-ui="article-input-item-top">
                  </div>
                </div>
              </div>
              <div class="p-2 flex flex-col gap-2 ">
                <button class="p-2 w-full bg-white hover:bg-trader-hover-background hover:text-white"
                        @click="splitSelectedItem">Kombinierte Platzhalter auflösen
                </button>
                <button class="p-2 w-full bg-white hover:bg-trader-hover-background hover:text-white"
                        @click="disableSelectedItem"> Platzhalter deaktivieren/aktivieren
                </button>
              </div>
            </template>
          </accordion-item>
        </accordion>
      </div>

      <div class="bg-primary p-2 flex flex-col gap-2 flex-grow" v-if="editMode">
        <button v-show="!(userData?.isAdmin || userData?.isMarketing)"
                class="p-2 w-full bg-white hover:bg-trader-hover-background hover:text-white"
                @click="splitSelectedItem">
          Kombinierte Platzhalter auflösen
        </button>

        <div class="flex-grow"></div>

        <!--
        <button :disabled="buttonIsSaving" v-if="!hideSaveButton" class="bg-green-300 p-2 w-full hover:bg-trader-hover-background hover:text-white"
                @click="saveData"
                data-ui="button-save-grid-settings">
          Speichern
        </button>
        -->
        <TRAsyncButton data-ui="button-save-grid-settings" v-if="!hideSaveButton" variant="save"
                       :saveSuccessful="!buttonIsSaving"
                       label="Speichern" loadingText="Speichere…" @click="saveData"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, getCurrentInstance, nextTick, onBeforeUnmount, onMounted, onUpdated, reactive, ref, watch} from 'vue';
import Accordion from "@/components/Accordion/Accordion";
import AccordionItem from "@/components/Accordion/AccordionItem";
import SignalBus from "@/application/SignalBus";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import {useStore} from "vuex";
import {mutation, query} from "@/graphql";
import Spinner from "@/components/Base/Spinner.vue";
import TRAsyncButton from "@/components/Base/v2/TRAsyncButton.vue";


//import {generateComputed, generateItemsComputed, getBackgroundColor, replaceCommasWithDots, drawFillRect, drawRect, drawRoundRect, drawText} from "./PageGridHelper"

const MM_TO_PIXEL = 2.835;
const isMergeMode = ref(true)
const isLayoutConfirmed = ref(false);


// default page settings
function getDefaultPageSettings() {
  return {
    page: {height: 297, width: 210, left: 4, right: 4, top: 4, bottom: 4, pageTemplateName: ''},
    cut: {top: 3, bottom: 3, left: 3, right: 3},
    //cut: {top: 0, bottom: 0, left: 0, right: 0},
    grid: {columns: 4, rows: 5, columnsGap: 3, rowsGap: 3},
    getGridByPage: {placeholders: 0}
  };
}

const buttonIsSaving = ref(false);

// some helper functions
function generateComputed(settings, obj, property) {
  return computed({
    get() {

      return settings[obj][property] || 0;
    },
    set(value) {

      let sanitizedValue = replaceCommasWithDots(value);
      let parsedValue = parseNumber(value);
      if (isNaN(parsedValue) || sanitizedValue === "") {
        settings[obj][property] = 0;
      } else {
        settings[obj][property] = parsedValue;
      }
      drawGrid();
    }
  });
}

function toggleMerge(mergeMode) {
  if (!isLayoutConfirmed.value) {
    isMergeMode.value = mergeMode;
  }
}

function resetLayout() {
  isLayoutConfirmed.value = false;
  isMergeMode.value = true;
  // Drag & Drop deaktivieren
}

function confirmLayout() {
  isLayoutConfirmed.value = true;
  isMergeMode.value = false;
  // Drag & Drop aktivieren
}

async function savePageTemplateWithProducts() {
  buttonIsSaving.value = true;
  try {
    const originalPlaceholder = items.value.filter(item => item.originalItem.length === 0);
    const dataCopy = JSON.parse(JSON.stringify(settings));
    let itemsCopy = items.value.filter(item => item.visible && !item.disabled);

    itemsCopy = itemsCopy.sort((a, b) => {
      if (a.y === b.y) {
        return a.x - b.x;
      }
      return a.y - b.y;
    });

    const gridData = {
      pageHeight: dataCopy.page.height,
      pageWidth: dataCopy.page.width,


      // CUT
      cutTop: dataCopy.cut.top,
      cutBottom: dataCopy.cut.bottom,
      cutLeft: dataCopy.cut.left,
      cutRight: dataCopy.cut.right,

      marginBottom: parseFloat(replaceCommasWithDots(dataCopy.page.bottom)),
      marginLeft: parseFloat(replaceCommasWithDots(dataCopy.page.left)),
      marginRight: parseFloat(replaceCommasWithDots(dataCopy.page.right)),
      marginTop: parseFloat(replaceCommasWithDots(dataCopy.page.top)),

      columns: dataCopy.grid.columns,
      rows: dataCopy.grid.rows,

      columnGap: parseFloat(replaceCommasWithDots(dataCopy.grid.columnsGap)),
      rowGap: parseFloat(replaceCommasWithDots(dataCopy.grid.rowsGap)),

      originalPlaceholders: originalPlaceholder.map(item => {
        return {
          id: item.id,
          arrX: item.arrX,
          arrY: item.arrY,
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height,
        };
      }),

      placeholders: itemsCopy.map(item => {
        let purchaser = item?.purchaser?.map(purchaser => {
          return purchaser.id;
        });
        return {
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height,
          originalPlaceholdersIndex: item.originalItem.map(item => item.id),
          purchaser: purchaser || [],
        };
      }),
    };
    let products = [];
    let purchasers = [];

    console.log("items.value:", items.value.filter(item => item.visible && !item.disabled))
    itemsCopy.forEach((item, index) => {
      let articleNumbersList = [];
      let indices = [];

      if (item.visible && !item.disabled) {

        if (item.articles && Array.isArray(item.articles)) {
          item.articles.forEach(articleObj => {
            if (articleObj.articleNumber && Array.isArray(articleObj.articleNumber)) {
              articleNumbersList.push(...articleObj.articleNumber);
            }
            if (articleObj.index !== undefined) {
              indices.push(articleObj.index);
            }
          });
        }

        products.push({
          articleNumbers: articleNumbersList|| [],
          virtualId: item.virtualId || 0,
          index: indices[0] || 0,
        });


        // Purchaser-Logik bleibt gleich
        if (item.purchaser && Array.isArray(item.purchaser) && item.purchaser.length > 0) {
          console.log("item:", item);
          console.log("item.purchaser:", item.purchaser, "index", item.index);
          item.purchaser.forEach(p => {
            purchasers.push({
              id: p.id,
              virtualId: item.virtualId || 0,
              index: item.index
            });
          });
        }
      }
    });

    articleNumbersOver.value.forEach(a => {
      products.push({
        articleNumbers: a.articles,
        virtualId: 0,
        index: -1,
      });
    });




    const [result, error] = await mutation.changePageTemplateWithProducts(
        parseInt(props.testPageId, 10),
        parseInt(props.templateId || 0, 10),
        purchasers,
        products,
        gridData
    );

    if (error) {
      throw new Error(error.message);
    }


  } catch (error) {
    console.error("Fehler beim Speichern des Templates:", error);
  } finally {
    SignalBus.emit("project-reload-purchaser-page");
    buttonIsSaving.value = false;
    // close Modal
    eventBus.closeModal()

  }
}

function generateItemsComputed(items, selectedItem, property) {
  return computed({
    get() {
      const item = items.value.find(item => item.id === selectedItem.value);
      if (item) {
        const val = parseFloat(item[property]);
        const decimalCount = val.toString().split(".")[1]?.length || 0;
        return (!isNaN(val) && decimalCount > 3) ? val.toFixed(2) : isNaN(val) ? "0" : val.toString();
      }
      return "";
    },
    set(value) {
      items.value.forEach((item, index) => {
        if (item.id === selectedItem.value) {
          items.value[index][property] = parseFloat(value);
        }
      });
      drawGrid();
    }
  });
}

function toPx(...args) {
  const scale = getScaleFactor();
  return args.map(value => value * (scale * MM_TO_PIXEL));
}

function replaceCommasWithDots(str) {
  return (typeof str === 'string') ? str.replace(/,/g, '.') : str;
}

function parseNumber(value) {
  return parseFloat(replaceCommasWithDots(value));
}

function getBackgroundColor(teamColor) {
  const color = teamColor.startsWith('#') ? teamColor.substring(1) : teamColor;
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 125 ? '#000000' : '#FFFFFF';
}

function hasSelection() {
  return (
      selectionStartItem.value !== null &&
      selectionMoveItem.value !== null &&
      selectionStartItem.value.id !== selectionMoveItem.value.id
  );
}

function getScaleFactor() {
  const canvasWidth = grid.value.width / dpi;
  const canvasHeight = grid.value.height / dpi;
  return Math.min(
      canvasWidth / ((data.page.width + 20) * MM_TO_PIXEL),
      canvasHeight / ((data.page.height + 20) * MM_TO_PIXEL)
  );
}

function getSelectionBounds() {
  if (!hasSelection()) return {x: 0, y: 0, width: 0, height: 0, purchaser: null};

  const tmp = [selectionStartItem.value, selectionMoveItem.value];
  const minX = Math.min(...tmp.map(rect => rect.x));
  const minY = Math.min(...tmp.map(rect => rect.y));
  const maxX = Math.max(...tmp.map(rect => rect.x + rect.width));
  const maxY = Math.max(...tmp.map(rect => rect.y + rect.height));

  let start = getTest(selectionStartItem.value)
  let end = getTest(selectionMoveItem.value)

  return {x: minX, y: minY, width: maxX - minX, height: maxY - minY, purchaser: selectionStartItem.value.purchaser};
}

function newGenerate() {
  Object.assign(data, JSON.parse(JSON.stringify(settings)));
  buildGrid(false);
  drawGrid();
}

// component props
const props = defineProps({
  value: {
    type: Object,
    default: () => ({})
  },
  editMode: {
    type: Boolean,
    default: true
  },
  hideSaveButton: {
    type: Boolean,
    default: false
  },
  pageID: {
    type: Number,
    default: 0
  },
  templateId: {
    type: [Number, String],
    default: 0,
  },
  changeTemplate: {
    type: Boolean,
    default: false
  },
  testPageId: {
    type: Number,
    default: 0
  },
  onClickPlaceholder: {
    type: Function,
    default: () => {
    }
  },
  gridId: String,
  mergeData: {
    type: Array,
    default: () => ([])
  }
});

// variables
const store = useStore();
const userData = computed(() => store.state.user.userData);
const gridDiv = ref(null);
const templateNameBar = ref(null);
const grid = ref(null);
const sizeRight = ref(4);
const sizeHeight = ref(5);
const mouseX = ref(null);
const mouseY = ref(null);
const mousedown = ref(false);
const selectRectangelles = ref([]);
const selectedRectangles = ref([]);
const selectionStartItem = ref(null);
const selectionMoveItem = ref(null);
const selectedItem = ref(null);
const isRectDraw = ref(false);
const items = ref([]);
const drawnRect = ref(null);
const allItems = ref(true);
const data = reactive(getDefaultPageSettings());
const settings = reactive(getDefaultPageSettings());
const purchaserGrid = ref([]);
const virtualID = ref(0);
const teamID = ref(0);
const color = ref("");
const teamIcon = ref("");
const placeholderData = ref([]);
const userPurchaseIds = ref([]);
const ready = ref(false);
const dpi = window.devicePixelRatio || 1;
const allOriginalItem = ref([]);
const allItemsInRect = ref([]);
const maxRect = ref({x: null, y: null,});
const minRect = ref({x: 1000, y: 1000,});
const lastValidItem = ref(null);
const draggedItem = ref(null);

const mergeRect = ref([]);

// computed properties
const areaHeight = computed(() => {
  return settings.page.height - settings.page.top - settings.page.bottom - settings.cut.top - settings.cut.bottom;
});

const areaWidth = computed(() => {
  return settings.page.width - settings.page.left - settings.page.right - settings.cut.left - settings.cut.right;
});

const cutTop = generateComputed(settings, 'cut', 'top');
const cutBottom = generateComputed(settings, 'cut', 'bottom');
const cutLeft = generateComputed(settings, 'cut', 'left');
const cutRight = generateComputed(settings, 'cut', 'right');
const pageTop = generateComputed(settings, 'page', 'top');
const pageBottom = generateComputed(settings, 'page', 'bottom');
const pageLeft = generateComputed(settings, 'page', 'left');
const pageRight = generateComputed(settings, 'page', 'right');
const itemHeight = generateItemsComputed(items, selectedItem, 'height');
const itemTop = generateItemsComputed(items, selectedItem, 'y');
const itemWidth = generateItemsComputed(items, selectedItem, 'width');
const itemLeft = generateItemsComputed(items, selectedItem, 'x');

const scale = ref(1);
const offsetX = ref(0);
const offsetY = ref(0);


// watch properties
watch(() => settings.grid.rowsGap, drawGrid);
watch(() => settings.grid.columnsGap, drawGrid);
watch(() => props.pageID, (newVal) => {
  loadData();
  drawGrid();
});

const {proxy} = getCurrentInstance();

onUpdated(() => {
  init();
});
onMounted(async () => {
  // Existing event listeners
  grid.value.addEventListener('drop-data', (event) => {
    draggedItem.value = event.detail;
  });

  grid.value.addEventListener('mousemove', handleMouseMove);
  grid.value.addEventListener('mousedown', handleMouseDown);
  grid.value.addEventListener('mouseup', handleMouseUp);

  //call init on browser resize
  window.addEventListener('resize', init);

  // Existing SignalBus connections
  SignalBus.connect(proxy, 'save_grid_for_template', saveData);
  SignalBus.connect(proxy, 'load_grid_for_template', loadData);
  SignalBus.connect(proxy, 'project-reload-purchaser-page', loadData);

  if (props.testPageId !== 0) {
    await getArticleNumbersByPageId(props.testPageId);
  } else {
    await getArticleNumbersByPageId(props.pageID);
  }

  await buildGrid();
  await drawGrid();
  await loadData();
  init();
  await nextTick(() => {
    init();
  });

});

const articleNumbers = ref([]);
const purchaser = ref([]);

const ArticleData = ref([])

async function getArticleNumbersByPageId(pageID) {

  pageID = pageID || props.testPageId || props.pageID;
  const [articleInformation, err] = await query.getArticleNumbersByPageId(pageID);
  if (err) {
    console.error("Fehler beim Abrufen der Artikelnummern:", err);
    return;
  }
  articleInformation.forEach(item => {
    articleNumbers.value.push({
      articleNumbers: item.articleNumbers,
      isPlaced: false,
      articlePurchaser: item.articlePurchaser

    })
    purchaser.value.push(item.purchaser)
  });


}


function fnv1a32(str) {
  let h = 0x811c9dc5; // Offset basis
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    // 32-bit FNV prime 16777619: via bit-ops multiplizieren
    h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
  }
  return h | 0;
}


function articleToRGB(articleNumber) {
  const str = String(articleNumber);

  let hash = 0;
  for (let i = 1; i < str.length -1; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }

  let hashB = fnv1a32(str);

  let valA = parseInt(articleNumber[0]) || 0;
  let valB = parseInt(articleNumber[articleNumber.length -1]) || 0;

  // Werte auf 0-180 begrenzen statt 0-255 für dunklere Farben
  let r = (Math.abs(valB) % 10) * 25;
  let g = (Math.abs(hashB >> 8) % 10) * 25;
  let b = (Math.abs(valA) % 10) * 25;
  let a =  50 +  (Math.abs(hash) % 5) * 40

  if(b % 2 === 0){
    b = 255 - b;
  }

  if(r % 2 === 0){
    r = 255 - r;
  }

  if(g % 2 === 0){
    g = 255 - g;
  }

  return {r, g, b, a};
}

// RGB zu Hex-String für Canvas fillStyle
function rgbToHex(r, g, b, a) {
  return '#' + [r, g, b, a].map(x => x.toString(16).padStart(2, '0')).join('');
}

// Hauptfunktion für Artikelnummer-Farbe
function getArticleColor(articleNumber) {
  const {r, g, b, a} = articleToRGB(articleNumber);
  return rgbToHex(r, g, b, a);
}

function init() {
  // Set canvas drawing buffer size based on parent size
  const canvas = grid.value;
  const parent = gridDiv.value;
  const template = templateNameBar.value;

  const rect = parent.getBoundingClientRect();
  const parentWidth = rect.width;
  let parentHeight = rect.height;

  const templateNameBarRect = template.getBoundingClientRect();
  const templateNameBarHeight = templateNameBarRect.height;

  parentHeight = parentHeight - templateNameBarHeight;

  canvas.width = parentWidth * dpi;
  canvas.height = parentHeight * dpi;

  // set canvas size
  canvas.style.width = parentWidth + 'px';
  canvas.style.height = parentHeight + 'px';

  offsetX.value = (((canvas.width / dpi) - (toPx(data.page.width))) / 2)
  offsetY.value = (((canvas.height / dpi) - (toPx(data.page.height))) / 2)


  // Scale the context to account for high DPI
  const ctx = canvas.getContext('2d');
  ctx.scale(dpi, dpi);


  drawGrid();
}


onBeforeUnmount(() => {

  window.removeEventListener('resize', init);

  SignalBus.disconnectAllFromParent(proxy);
  if (grid.value) {
    grid.value.removeEventListener('mousemove', handleMouseMove);
    grid.value.removeEventListener('mousedown', handleMouseDown);
    grid.value.removeEventListener('mouseup', handleMouseUp);
  }
});

// mouse events
function handleMouseMove(event) {

  const scale = getScaleFactor();
  const canvasRect = grid.value.getBoundingClientRect();
  if (scale != null) {

    mouseX.value = (event.clientX - canvasRect.left - offsetX.value) / (scale * MM_TO_PIXEL);
    mouseY.value = (event.clientY - canvasRect.top - offsetY.value) / (scale * MM_TO_PIXEL);
    const item = collisionWithMouse();
    if (item !== null && props.editMode || props.changeTemplate && isMergeMode.value) {
      items.value.forEach(item => {
        item.articles = []
      })
      selectionMoveItem.value = item;
    }
    drawGrid();
  }
}


function handleMouseDown(event) {
  mousedown.value = true;
  selectionStartItem.value = collisionWithMouse();
}

function getTest(obj) {
  if (obj === null) {
    return null;
  }

  // ));
  let min = {x: 1000, y: 1000};
  let max = {x: null, y: null};

  if (obj.originalItem.length > 0) {
    let items = obj?.originalItem || obj;
    items.forEach(item => {
      max.x = Math.max(max.x, item.arrX);
      max.y = Math.max(max.y, item.arrY);
      min.x = Math.min(min.x, item.arrX);
      min.y = Math.min(min.y, item.arrY);
    });
  } else {
    max.x = obj.arrX;
    max.y = obj.arrY;
    min.x = obj.arrX;
    min.y = obj.arrY;
  }

  return {
    min: min,
    max: max
  };
}

function checkIfMergeIsTrue() {

  const itemsVisible = items.value.filter(item => item.visible);
  let merge = true


  const newItem = collisionWithMouse();

  if (newItem == null || selectionStartItem.value == null) {
    return merge;
  }
  const item = collisionWithMouse();


  let startItem = getTest(selectionStartItem.value);
  let endItem = getTest(item);


  let minRect = {x: Math.min(startItem.min.x, endItem.min.x), y: Math.min(startItem.min.y, endItem.min.y)};
  let maxRect = {x: Math.max(startItem.max.x, endItem.max.x), y: Math.max(startItem.max.y, endItem.max.y)};

  let newItems = [];
  itemsVisible.forEach(item => {
    let items = item?.originalItem || item;
    items.forEach(originalItem => {
      let x = originalItem.arrX
      let y = originalItem.arrY
      //is inside
      if (x >= minRect.x && x <= maxRect.x && y >= minRect.y && y <= maxRect.y) {
        if (!newItems.includes(items)) {
          newItems.push(items);
        }
      }
    });
  });

  newItems.forEach(item => {
    let items = item?.originalItem || item;
    items.forEach(originalItem => {
      if (!(originalItem.arrX >= minRect.x && originalItem.arrX <= maxRect.x && originalItem.arrY >= minRect.y && originalItem.arrY <= maxRect.y)) {
        merge = false;
      }
    });
  });

  getItem()
  return merge;
}

function getMergeItems() {
  const itemsVisible = items.value.filter(item => item.visible);
  let merge = true
  const item = collisionWithMouse();


  if (item == null || selectionStartItem.value == null) {
    return;
  }

  let startItem = getTest(selectionStartItem.value);
  let endItem = getTest(item);


  let minRect = {x: Math.min(startItem.min.x, endItem.min.x), y: Math.min(startItem.min.y, endItem.min.y)};
  let maxRect = {x: Math.max(startItem.max.x, endItem.max.x), y: Math.max(startItem.max.y, endItem.max.y)};

  let newItems = [];
  itemsVisible.forEach(item => {
    let items = item?.originalItem || item;
    if (item?.originalItem.length === 0) {
      let x = item.arrX
      let y = item.arrY
      //is inside
      if (x >= minRect.x && x <= maxRect.x && y >= minRect.y && y <= maxRect.y) {
        if (!newItems.includes(items)) {
          newItems.push(items);
        }
      }
    } else {
      items.forEach(originalItem => {
        let x = originalItem.arrX
        let y = originalItem.arrY
        if (x >= minRect.x && x <= maxRect.x && y >= minRect.y && y <= maxRect.y) {
          if (!newItems.includes(items)) {
            newItems.push(items);
          }
        }
      });
    }

  });

  newItems.forEach(item => {
    let items = item?.originalItem || item;
    items.forEach(originalItem => {
      if (!(originalItem.arrX >= minRect.x && originalItem.arrX <= maxRect.x && originalItem.arrY >= minRect.y && originalItem.arrY <= maxRect.y)) {
        merge = false;
      }
    });
  });
  if (merge) {
    return newItems;
  } else {
    return [];
  }

}

function handleMouseUp() {

  const endItem = collisionWithMouse();
  const startIndex = items.value.findIndex(item => item?.id === selectionStartItem.value?.id);
  const endIndex = items.value.findIndex(item => item?.id === endItem?.id);

  if (props.changeTemplate) {
    if (!endItem || !selectionStartItem.value) return;
    if (startIndex === -1 || endIndex === -1) return;

    // Artikelnummern extrahieren (oder leere Arrays wenn keine vorhanden)
    const startArticleNumbers = (items.value[startIndex].articles || []).map(article => article.articleNumber);
    const endArticleNumbers = (items.value[endIndex].articles || []).map(article => article.articleNumber);

    // Sicherstellen dass beide Items articles Arrays haben
    if (!items.value[startIndex].articles) {
      items.value[startIndex].articles = [];
    }
    if (!items.value[endIndex].articles) {
      items.value[endIndex].articles = [];
    }

    // Die maximale Anzahl von Artikeln bestimmen
    const maxLength = Math.max(startArticleNumbers.length, endArticleNumbers.length);

    // Start-Array anpassen
    for (let i = 0; i < maxLength; i++) {
      if (i >= items.value[startIndex].articles.length) {
        // Neuen Artikel erstellen falls nötig
        items.value[startIndex].articles.push({ articleNumber: '' });
      }
      items.value[startIndex].articles[i].articleNumber = endArticleNumbers[i] || '';
    }
    // End-Array anpassen
    for (let i = 0; i < maxLength; i++) {
      if (i >= items.value[endIndex].articles.length) {
        // Neuen Artikel erstellen falls nötig
        items.value[endIndex].articles.push({ articleNumber: '' });
      }
      items.value[endIndex].articles[i].articleNumber = startArticleNumbers[i] || '';
    }

    // Überschüssige Artikel entfernen
    items.value[startIndex].articles = items.value[startIndex].articles.slice(0, maxLength);
    items.value[endIndex].articles = items.value[endIndex].articles.slice(0, maxLength);

    // Purchaser wie vorher komplett tauschen
    const tempStartPurchaser = items.value[startIndex].purchaser || [];
    items.value[startIndex].purchaser = items.value[endIndex].purchaser || [];
    items.value[endIndex].purchaser = tempStartPurchaser;

    drawGrid();
  }


  if (hasSelection()) {
    let rect = getSelectionBounds();

    let merge = checkIfMergeIsTrue();

    if (merge) {
      const selectionRect = getSelectionBounds();
      let selectedItems = items.value.filter(item => {
        const itemRight = item.x + item.width;
        const itemBottom = item.y + item.height;
        const selectionRight = selectionRect.x + selectionRect.width;
        const selectionBottom = selectionRect.y + selectionRect.height;
        return (
            item.x >= selectionRect.x &&
            item.y >= selectionRect.y &&
            itemRight <= selectionRight &&
            itemBottom <= selectionBottom && item.visible
        );
      });
      let purchaser = [];

      selectedItems?.forEach(item => {
        item?.purchaser?.forEach(purchaserItem => {
          if (!purchaser.includes(purchaserItem.id)) {
            purchaser.push(purchaserItem.id);
          }
        });
      });

      let valid = false;
      if (purchaser.every(purchaserId => userPurchaseIds.value.includes(purchaserId)) || userData.value?.isAdmin || userData.value?.isMarketing) {
        valid = true;
      }

      if (valid) {
        let originalItem = hideAllSelectedItem();
        items.value.push({
          id: items.value.length,
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height,
          visible: true,
          originalItem: originalItem,
          purchaser: rect.purchaser,
        });
      }
    }
  }


  const item = collisionWithMouse();

  allItemsInRect.value = [];
  maxRect.value = {x: null, y: null};
  minRect.value = {x: 1000, y: 1000};
  if (item !== null) {
    selectedItem.value = item.id;
    props.onClickPlaceholder(item);
  }
  mousedown.value = false;

  selectRectangelles.value = [];
  selectionStartItem.value = null;
  selectionMoveItem.value = null;


  // wichtig damit die Artikelnummern und purchaser beim chagetemplate richtig akutualisiert werden macht gerade ein Problem das man keine Artikel mehr tauschen kann

  /*
    if (props.changeTemplate) {
      items.value.forEach(item => {
        item.articles = [];
        item.purchaser = [];
      });
    }
  */


  drawGrid();
}

// here starts the real logic
async function saveData(options = {}) {
  const defaultoPxions = {
    hideModal: false,
  };
  buttonIsSaving.value = true;
  options = {...defaultoPxions, ...options};

  try {
    let pageId = props.pageID;
    if (props.pageID === 0) {
      pageId = props.value.pageId;
    }

    //const dataCopy = data;
    const dataCopy = JSON.parse(JSON.stringify(settings));
    let itemsCopy = items.value.filter(item => item.visible && !item.disabled);


    itemsCopy = itemsCopy.sort((a, b) => {
      if (a.y === b.y) {
        return a.x - b.x;
      }
      return a.y - b.y;
    });

    const originalPlaceholder = items.value.filter(item => item.originalItem.length === 0);
    const gridData = {
      pageHeight: dataCopy.page.height,
      pageWidth: dataCopy.page.width,


      // CUT
      cutTop: dataCopy.cut.top,
      cutBottom: dataCopy.cut.bottom,
      cutLeft: dataCopy.cut.left,
      cutRight: dataCopy.cut.right,

      marginBottom: parseFloat(replaceCommasWithDots(dataCopy.page.bottom)),
      marginLeft: parseFloat(replaceCommasWithDots(dataCopy.page.left)),
      marginRight: parseFloat(replaceCommasWithDots(dataCopy.page.right)),
      marginTop: parseFloat(replaceCommasWithDots(dataCopy.page.top)),

      columns: dataCopy.grid.columns,
      rows: dataCopy.grid.rows,

      columnGap: parseFloat(replaceCommasWithDots(dataCopy.grid.columnsGap)),
      rowGap: parseFloat(replaceCommasWithDots(dataCopy.grid.rowsGap)),

      originalPlaceholders: originalPlaceholder.map(item => {
        return {
          id: item.id,
          arrX: item.arrX,
          arrY: item.arrY,
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height,
        };
      }),

      placeholders: itemsCopy.map(item => {
        let purchaser = item?.purchaser?.map(purchaser => {
          return purchaser.id;
        });
        return {
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height,
          originalPlaceholdersIndex: item.originalItem.map(item => item.id),
          purchaser: purchaser || [],
        };
      }),
    };


    const [success, err] = props.templateId != 0
        ? await mutation.editGridForTemplate(props.templateId, gridData)
        : await mutation.editGridForPage(pageId, gridData);

    if (!options.hideModal) {
      if (success) {
        eventBus.openModal(SuccessConfirmation);
        eventBus.setData({
          title: "Raster gespeichert",
          message: "Das Raster wurde gespeichert.",
        });
      }
    }


    SignalBus.emit('project-reload-purchaser-page');
    SignalBus.emit('reload-save-grid');
    SignalBus.emit('reload-clipboard');


  } catch (error) {
    console.error("Daten konnten nicht aktualisiert werden.", error);
    throw error;
  } finally {
    buttonIsSaving.value = false;
  }
}

async function loadData(templateId) {
  if (!templateId) {
    templateId = props.templateId;
  }

  const [dataFetched, err] = templateId != 0
      ? await query.getGridByTemplateId(templateId)
      : await query.getGridByPage(props.pageID || props.value.pageId);

  try {
    data.pageTemplateName = dataFetched.pageTemplateName;
    data.page.top = dataFetched.marginTop;
    data.page.bottom = dataFetched.marginBottom;
    data.page.left = dataFetched.marginLeft;
    data.page.right = dataFetched.marginRight;
    data.cut.top = dataFetched.cutTop;
    data.cut.bottom = dataFetched.cutBottom;
    data.cut.left = dataFetched.cutLeft;
    data.cut.right = dataFetched.cutRight;
    data.grid.columns = dataFetched.columns;
    data.grid.rows = dataFetched.rows;
    data.grid.columnsGap = dataFetched.columnGap;
    data.grid.rowsGap = dataFetched.rowGap;
    data.page.height = dataFetched.pageHeight;
    data.page.width = dataFetched.pageWidth;

    userPurchaseIds.value = dataFetched.userPurchaseIds;

    items.value = [];
    placeholderData.value = dataFetched.placeholders;
    buildGrid();

    dataFetched.placeholders.forEach((placeholder) => {
      if (placeholder.originalPlaceholdersIndex.length === 0) {
        items.value.forEach((item) => {

          if (item.x === placeholder.x && item.y === placeholder.y && item.width === placeholder.width && item.height === placeholder.height) {
            item.virtualId = placeholder.virtualId;
            item.purchaser = placeholder.purchaser;
          }
        });
      }
    });

    dataFetched.placeholders.forEach((placeholder) => {
      // dieses größer gleich 0 ist wichtig, da es sonst zu einem Fehler kommt beim anzeigen der artikel es kann aber sein das es woanders noch zu einem Fehler kommt
      if (placeholder.originalPlaceholdersIndex.length > 0) {
        let originalItems = [];
        placeholder.originalPlaceholdersIndex.forEach((index) => {
          items.value[index].visible = false;
          originalItems.push(items.value[index]);
        })
        items.value.push({
          id: items.value.length,
          x: placeholder.x,
          y: placeholder.y,
          width: placeholder.width,
          height: placeholder.height,
          visible: true,
          originalItem: originalItems,
          virtualId: placeholder.virtualId,
          purchaser: placeholder.purchaser,
          articles: placeholder.article,
        });
      }
    });


    await nextTick(() => {
      Object.assign(settings, JSON.parse(JSON.stringify(data)));
    });
    drawGrid();
    //handleMouseUp();
  } catch (error) {
    console.error(error);
  }

  ready.value = true;
}

function buildGrid(filterItems = true) {
  items.value = [];

  for (let y = 0; y < data.grid.rows; y++) {
    for (let x = 0; x < data.grid.columns; x++) {
      let columnGap = parseNumber(data.grid.columnsGap);
      let rowsGap = parseNumber(data.grid.rowsGap);
      let realPageWidth = data.page.width - data.page.left - data.page.right - data.cut.left - data.cut.right;

      let itemWidth = (realPageWidth - (data.grid.columns - 1) * columnGap) / data.grid.columns;
      let realPageHeight = data.page.height - data.page.top - data.page.bottom - data.cut.top - data.cut.bottom;
      let itemHeight = (realPageHeight - (data.grid.rows - 1) * rowsGap) / data.grid.rows;


      items.value.push({
        id: items.value.length,
        arrX: x,
        arrY: y,
        x: (x * (itemWidth + columnGap) + data.page.left),
        y: (y * (itemHeight + rowsGap) + data.page.top),
        width: itemWidth,
        height: itemHeight,
        visible: true,
        originalItem: [],
        virtualId: 0,
      });

    }
  }
  if (filterItems) {
    items.value.forEach((item) => {
      let found = false;
      placeholderData.value.forEach((placeholder) => {
        if ((item.x === placeholder.x && item.y === placeholder.y)) {
          found = true;
        }
      });
      if (!found) {
        item.disabled = true;
      }
    });
  }
  drawGrid();
}

function collisionWithMouse() {
  let result = null;

  items.value.forEach(item => {
    const translatedItem = {
      x: item.x + data.cut.left, y: item.y + data.cut.top,
      width: item.width, height: item.height
    };
    if (mouseX.value >= translatedItem.x && mouseX.value <= translatedItem.x + translatedItem.width &&
        mouseY.value >= translatedItem.y && mouseY.value <= translatedItem.y + translatedItem.height) {
      if (mousedown.value && !selectRectangelles.value.includes(item) && item.visible) {
        result = item;
      }
    }
  });

  return result;
}

function collisionRectInRect() {
  /*
  const itemsVisible = items.value.filter(item => item.visible);
  const drawRect = getSelectionBounds();
  let validItems = [];


  itemsVisible.forEach(item => {
    // Prüfen, ob das Item überhaupt mit drawRect kollidiert
    if (
        item.x < drawRect.x + drawRect.width &&
        item.x + item.width > drawRect.x &&
        item.y < drawRect.y + drawRect.height &&
        item.y + item.height > drawRect.y
    ) {
      // Prüfen, ob das Item vollständig im drawRect liegt
      const fullyInsideDraw =
          item.x >= drawRect.x &&
          item.x + item.width <= drawRect.x + drawRect.width &&
          item.y >= drawRect.y &&
          item.y + item.height <= drawRect.y + drawRect.height;

      if (fullyInsideDraw) {
        // Vollständig im drawRect → push, egal ob es überlappt
        validItems.push(item);
      } else {
        // Teilweise im drawRect → nur pushen, wenn keine Überlappung mit einem anderen sichtbaren Item vorliegt
        let overlaps = false;
        itemsVisible.forEach(other => {
          if (other !== item) {
            if (
                item.x < other.x + other.width &&
                item.x + item.width > other.x &&
                item.y < other.y + other.height &&
                item.y + item.height > other.y
            ) {
              overlaps = true;
            }
          }
        });
        if (!overlaps){
          validItems.push(item);
        }


      }
    }
  });



  // Entferne aus allItemsInRect Items, die nicht mehr sichtbar sind
  allItemsInRect.value = allItemsInRect.value.filter(item => itemsVisible.includes(item));

  // Füge alle validItems zu allItemsInRect hinzu, falls noch nicht vorhanden
  validItems.forEach(item => {
    if (!allItemsInRect.value.includes(item)) {
      allItemsInRect.value.push(item);
    }
  });

  // allItems.value zeigt an, ob alle validItems vollständig im drawRect liegen
  allItems.value = validItems.every(item =>
      item.x >= drawRect.x &&
      item.x + item.width <= drawRect.x + drawRect.width &&
      item.y >= drawRect.y &&
      item.y + item.height <= drawRect.y + drawRect.height
  );

   */
}

function getItem() {
  let currentItem = collisionWithMouse();

  if (!currentItem) {
    if (lastValidItem.value) {
      // Verwende den zuletzt gültigen Wert
      currentItem = lastValidItem.value;

    } else {
      currentItem = selectionStartItem.value;
      lastValidItem.value = currentItem;
    }
  } else {
    lastValidItem.value = currentItem;
  }

  return currentItem;
}

function hideAllSelectedItem() {
  // Versuche, ein neues Collision-Ergebnis zu erhalten


  let currentItem = getItem();
  // Verarbeite currentItem weiter
  let startItem = getTest(selectionStartItem.value);
  let endItem = getTest(currentItem);

  let minRect = {
    x: Math.min(startItem.min.x, endItem.min.x),
    y: Math.min(startItem.min.y, endItem.min.y)
  };
  let maxRect = {
    x: Math.max(startItem.max.x, endItem.max.x),
    y: Math.max(startItem.max.y, endItem.max.y)
  };

  let visibleItems = items.value.filter(item => item.visible);

  const originalItems = [];
  visibleItems.forEach(item => {
    if (item.originalItem.length > 0) {
      item.originalItem.forEach(originalItem => {
        if (
            originalItem.arrX >= minRect.x &&
            originalItem.arrX <= maxRect.x &&
            originalItem.arrY >= minRect.y &&
            originalItem.arrY <= maxRect.y
        ) {
          item.visible = false;
          originalItems.push(originalItem);
        }
      });
    } else {
      if (
          item.arrX >= minRect.x &&
          item.arrX <= maxRect.x &&
          item.arrY >= minRect.y &&
          item.arrY <= maxRect.y
      ) {
        item.visible = false;
        originalItems.push(item);
      }
    }
  });

  lastValidItem.value = null;
  return originalItems;
}

const emit = defineEmits(['articleNumbersUpdate']);
const articleNumbersOver = computed(() => {
  if (!props.changeTemplate || !articleNumbers.value) {
    return [];
  }

  const visibleItemsCount = items.value.filter(item => item.visible).length;

  if (visibleItemsCount > articleNumbers.value.length) {
    return [];
  }

  // Behalte die Struktur bei, aber extrahiere nur articleNumbers
  return articleNumbers.value
      .slice(visibleItemsCount)
      .map(item => ({
        articles: item.articleNumbers, // Das Array der zusammengehörenden Artikel
        index: visibleItemsCount + articleNumbers.value.slice(visibleItemsCount).indexOf(item)
      }));
});

watch(articleNumbersOver, (newValue) => {
  emit('articleNumbersUpdate', newValue);
}, {immediate: true, deep: true});


// watch props.pageID
watch(() => props.pageID, (newVal) => {
  if (newVal !== 0) {
    getArticleNumbersByPageId(newVal);
  }
});

function drawGrid() {

  const ctx = grid.value.getContext('2d');
  ctx.save();
  ctx.clearRect(0, 0, grid.value.width, grid.value.height);
  ctx.translate(offsetX.value, offsetY.value);

  // Hintergrund
  ctx.fillStyle = 'rgba(255,255,255,0.6)';
  drawFillRect(0, 0, data.page.width, data.page.height);
  ctx.strokeStyle = 'rgba(0,0,0,0.6)';
  drawRect(0, 0, data.page.width, data.page.height);

  // Schnittmarken
  ctx.setLineDash([6]);
  const cutX = data.cut.left;
  const cutY = data.cut.top;
  const cutWidth = data.page.width - data.cut.right - data.cut.left;
  const cutHeight = data.page.height - data.cut.bottom - data.cut.top;

  ctx.fillStyle = 'rgb(255,255,255)';
  drawFillRect(cutX, cutY, cutWidth, cutHeight);
  ctx.strokeStyle = 'rgba(0,0,0,0.6)';
  drawRect(cutX, cutY, cutWidth, cutHeight);

// VOR der Schleife definieren!
  items.value.forEach((item, i) => {

    if (item.articles === undefined) {
      item.purchaser = [];
      item.articles = []
    }
    if (props.changeTemplate && isMergeMode.value) {
      item.purchaser = [];
      item.articles = []
    }

    if (item.visible) {
      const translatedItem = {
        x: item.x + data.cut.left,
        y: item.y + data.cut.top,
        width: item.width,
        height: item.height,
      };
      ctx.setLineDash([]);
      ctx.fillStyle = item.disabled ? 'rgba(230,230,230,0.5)' : 'rgba(230,230,230,0.8)';
      if (!item.disabled) {
        drawFillRect(translatedItem.x, translatedItem.y, translatedItem.width, translatedItem.height);
        ctx.strokeStyle = item.disabled ? 'transparent' : 'rgba(180,180,180,1)';
        drawRect(translatedItem.x, translatedItem.y, translatedItem.width, translatedItem.height);
      }
      if (item.id === selectedItem.value) {
        ctx.fillStyle = '#576b80';
        drawFillRect(translatedItem.x, translatedItem.y, translatedItem.width, translatedItem.height);
      }
      if (item.disabled) {
        drawStripedRectangle(translatedItem.x, translatedItem.y, translatedItem.width, translatedItem.height);
      }
      if (props.editMode || props.testPageId !== 0) {
        ctx.save();
        ctx.fillStyle = item.id === selectedItem.value ? 'white' : '#606060';
        const fontSize = 40 * getScaleFactor();
        ctx.font = fontSize + 'px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const name = findRectanglePosition(items.value, item);
        drawText(name === -1 ? '' : name, translatedItem.x + translatedItem.width / 2, translatedItem.y + translatedItem.height / 2);
        ctx.restore();
      }


      let index = findRectanglePosition(items.value, item) - 1;
      // Zuerst prüfen ob eine Artikelnummer existiert und ob sie bereits vergeben ist
      let artikelBereitsVergeben = false;
      let hatArtikelnummer = false

      if (props.changeTemplate && articleNumbers.value && index < articleNumbers.value.length) {
        const aktuelleArtikelnummer = articleNumbers.value[index]?.articleNumbers;

        // Prüfen ob überhaupt eine Artikelnummer vorhanden ist
        if (aktuelleArtikelnummer) {
          hatArtikelnummer = true;

          artikelBereitsVergeben = items.value.some(existingItem =>
              existingItem.visible &&
              existingItem.articles?.some(article =>
                  article.articleNumber === aktuelleArtikelnummer
              )
          );
        }
      }

      // - wenn Artikelnummer vorhanden aber noch nicht vergeben ist
      if (props.changeTemplate && purchaser.value && index < purchaser.value.length && purchaser.value[index]?.id > 0) {
        if (item.purchaser?.length === 0) {
          if (!hatArtikelnummer || !artikelBereitsVergeben) {
            item.purchaser = [purchaser.value[index]];
          }
        }
      }
      // Artikel zuweisen wenn vorhanden und noch nicht vergeben
      if (props.changeTemplate && articleNumbers.value && index < articleNumbers.value.length) {
        const aktuelleArtikelnummer = articleNumbers.value[index]?.articleNumbers;
        if (aktuelleArtikelnummer && !artikelBereitsVergeben && item.articles?.length === 0) {
          item.articles = [{articleNumber: aktuelleArtikelnummer, index: index}];
          item.index = index;
        }
      }
      isSplitting.value = false;
      let articlePurchaser = []
      let articleNumberArray = item.articles?.map((p) => p?.articleNumber);
      articleNumbers.value.forEach((article, i) => {
        //console.log(article?.articleNumbers[0] , "===" , item.articles[0]?.articleNumber);
        if (article?.articleNumbers[0] === item.articles[0]?.articleNumber) {
          articlePurchaser = article?.articlePurchaser;
        }
        if (articlePurchaser.length === 0) {
          if (article?.articleNumbers[0] === item.articles[0]?.articleNumber[0]) {
            articlePurchaser = article?.articlePurchaser;
          }
        }
      });

      item.purchaser?.forEach((p, i) => {
        const rectX = 1 + translatedItem.x + i * 24;
        const rectY = 1 + translatedItem.y;
        const fontSize = 18 * getScaleFactor();
        ctx.font = 'bold ' + fontSize + 'px Arial';
        //ctx.font = 'bold 15px Arial';
        ctx.textBaseline = 'middle';
        //center text
        ctx.textAlign = 'center';
        ctx.fillStyle = '#' + p.color;
        drawRoundRect(rectX, rectY, 22, 10, 2);
        ctx.fill();
        ctx.fillStyle = getBackgroundColor(p.color);
        drawText(p.teamIcon, rectX + 11, translatedItem.y + 6.5);
      });

      if (articleNumberArray?.length > 0 && articleNumberArray[0] !== '') {
        const rectX = 1 + translatedItem.x ;
        const rectY = 1 + translatedItem.y;
        const fontSize = 18 * getScaleFactor();
        const articleText = articleNumberArray.join(",");
        ctx.font = 'bold ' + fontSize + 'px Arial';
        ctx.textBaseline = 'middle';
        // Nur bei testPageId !== 0: Hintergrund mit farbigem Rechteck
        if (props.testPageId !== 0) {
          // Textbreite messen für Hintergrund-Rechteck
          const textMetrics = ctx.measureText(articleText);
          const textWidth = textMetrics.width;
          const rectWidth = textWidth - 10; // Macht das Rechteck um 10px schmaler
          // Farbiger Hintergrund zeichnen
          const articleColor = getArticleColor(articleNumberArray.join(','));
          ctx.fillStyle = articleColor;
          drawRoundRect(rectX, rectY + 12, rectWidth, fontSize, 2);
          ctx.fill();
          ctx.textAlign = 'center';
          ctx.fillStyle = getBackgroundColor(articleColor.substring(1)); // # entfernen
          drawText(articleText, rectX + (rectWidth / 2), translatedItem.y + 20);
        } else {
          ctx.textAlign = 'left';
          ctx.fillStyle = '#000000';
          drawText(articleText, rectX + 2, translatedItem.y + 16);
        }

        // articlePurchaser bleibt unverändert
        if (articlePurchaser.length > 0) {
          articlePurchaser?.forEach((p, i) => {
            const rectX = 1 + translatedItem.x + i * 24;
            const rectY = 1 + translatedItem.y;
            const fontSize = 18 * getScaleFactor();
            ctx.font = 'bold ' + fontSize + 'px Arial';
            ctx.textBaseline = 'middle';
            ctx.textAlign = 'center';
            ctx.fillStyle = '#aa0011';
            drawText(p.teamIcon, rectX + 8, translatedItem.y + item.height - 4);
          });
        }
      }
    }
  });

  let merge = checkIfMergeIsTrue();
  if (merge) {
    const selectionRect = getSelectionBounds();
    ctx.strokeStyle = 'black';
    ctx.fillStyle = 'rgba(128, 128, 128, 0.4)';
    selectionRect.x += data.cut.left;
    selectionRect.y += data.cut.top;
    drawRect(selectionRect.x, selectionRect.y, selectionRect.width, selectionRect.height);
    drawFillRect(selectionRect.x, selectionRect.y, selectionRect.width, selectionRect.height);
  } else {
    const selectionRect = getSelectionBounds();
    ctx.strokeStyle = 'black';
    ctx.fillStyle = 'rgba(255, 0, 0, 0.4)';
    selectionRect.x += data.cut.left;
    selectionRect.y += data.cut.top;
    drawRect(selectionRect.x, selectionRect.y, selectionRect.width, selectionRect.height);
    drawFillRect(selectionRect.x, selectionRect.y, selectionRect.width, selectionRect.height);
  }

  ctx.fillStyle = 'yellow';
  //ctx.fillRect(0, 0, grid.value.width, grid.value.height)
  ctx.restore();
}

const isSplitting = ref(false);

function splitSelectedItem() {

  isSplitting.value = true;
  items.value.forEach(item => {
    item.articles = [];
    item.purchaser = [];
    if (selectedItem.value === item.id && item.originalItem.length > 0) {
      item.visible = false;


      let columnCount = data.grid.columns;

      let min = {x: 1000, y: 1000}
      let max = {x: null, y: null}
      item.originalItem.forEach((originalItem, index) => {
        max.y = Math.max(max.y, Math.floor(originalItem.id / columnCount));
        max.x = Math.max(max.x, originalItem.id % columnCount);
        min.y = Math.min(min.y, Math.floor(originalItem.id / columnCount));
        min.x = Math.min(min.x, originalItem.id % columnCount);
      });
      let selectedRows = (max.y - min.y) + 1
      let selectedColumns = (max.x - min.x) + 1

      item.originalItem.forEach((originalItem) => {
        let indexX = originalItem.id % columnCount - min.x;
        let indexY = originalItem.arrY - min.y;
        originalItem.width = (item.width - (data.grid.columnsGap * (selectedColumns - 1))) / selectedColumns;
        originalItem.height = (item.height - (data.grid.rowsGap * (selectedRows - 1))) / selectedRows;
        originalItem.x = item.x + originalItem.width * indexX + (data.grid.columnsGap * indexX);
        originalItem.y = item.y + originalItem.height * indexY + (data.grid.rowsGap * indexY);
        originalItem.visible = true;
        originalItem.purchaser = item.purchaser;
        originalItem.disabled = false;
      })
    }
  });
  selectedItem.value = null; // Deselect item
  drawGrid();
}

function disableSelectedItem() {
  items.value.forEach(item => {
    item.disabled = (selectedItem.value === item.id) ? !item.disabled : item.disabled;
  });
  selectedItem.value = null;
  drawGrid();
}

function findRectanglePosition(rectangles, targetRectangle) {
  const visibleItems = rectangles.filter(item => item.visible && !item.disabled);
  const sortedRectangles = [...visibleItems].sort((a, b) => (a.y === b.y ? a.x - b.x : a.y - b.y));
  for (let i = 0; i < sortedRectangles.length; i++) {
    if (sortedRectangles[i].x === targetRectangle.x && sortedRectangles[i].y === targetRectangle.y &&
        sortedRectangles[i].width === targetRectangle.width && sortedRectangles[i].height === targetRectangle.height) {
      return i + 1;
    }
  }
  return -1;
}

// only canvas draw functions
function drawFillRect(x, y, width, height) {
  [x, y, width, height] = toPx(x, y, width, height);
  grid.value.getContext('2d').fillRect(x, y, width, height);
}

function drawRect(x, y, width, height) {
  const ctx = grid.value.getContext('2d');
  [x, y, width, height] = toPx(x, y, width, height);
  ctx.beginPath();
  ctx.rect(x, y, width, height);
  ctx.stroke();
  ctx.closePath();
}

function drawStripedRectangle(x, y, width, height) {
  const ctx = grid.value.getContext('2d');
  [x, y, width, height] = toPx(x, y, width, height);

  ctx.save();

  ctx.beginPath();
  ctx.rect(x, y, width, height);
  ctx.clip();

  ctx.lineWidth = 2;
  ctx.strokeStyle = 'rgba(0,0,0,0.05)';

  ctx.beginPath();
  ctx.rect(x, y, width, height);
  ctx.stroke();

  ctx.beginPath();
  ctx.lineWidth = 5;
  const lineSpacing = 15
  for (let i = -height; i < width; i += lineSpacing) {
    let startX = Math.max(x, x + i);
    let startY = y + (startX - (x + i));
    let endX = Math.min(x + width, x + i + height);
    let endY = y + (endX - (x + i));

    ctx.moveTo(startX, startY);
    ctx.lineTo(endX, endY);
  }
  ctx.stroke();

  ctx.restore();
}

function drawRoundRect(x, y, width, height, radius) {
  const ctx = grid.value.getContext('2d');
  [x, y, width, height, radius] = toPx(x, y, width, height, radius);
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(
      x + width,
      y + height,
      x + width - radius,
      y + height
  );
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
}

function drawText(text, x, y) {
  const ctx = grid.value.getContext('2d');
  [x, y] = toPx(x, y);
  ctx.fillText(text, x, y);
}
</script>